import * as React from "react";

import {
  buildGoogleFontApiUrl,
  GOOGLE_FONTS_SET,
} from "replo-runtime/shared/utils/font";

interface FontConfig {
  name: string;
  weight?: number;
}

/**
 * Hook that inserts Google Fonts into the document head.
 * Takes an array of fonts and automatically loads them from Google Fonts if they're available.
 *
 * @param fonts - Array of font configurations with name and optional weight
 */
export const useInsertGoogleFontsUrl = (fonts: FontConfig[]) => {
  React.useEffect(() => {
    const googleFonts = new Set<string>();

    fonts.forEach((font) => {
      if (font.name && GOOGLE_FONTS_SET.has(font.name)) {
        googleFonts.add(font.name);
      }
    });

    if (googleFonts.size > 0) {
      const googleFontUrl = buildGoogleFontApiUrl(Array.from(googleFonts));
      if (googleFontUrl) {
        const link = document.createElement("link");
        link.href = googleFontUrl;
        link.rel = "stylesheet";
        document.head.append(link);

        return () => {
          link.remove();
        };
      }
    }
  }, [fonts]);
};
